export const rollcallmanualattendancelistdata = [
    {
      "sno": 1,
      "name": "John Doe",
      "actualShift": "Morning Shift",
      "entryTime": "08:30 AM",
      "exitTime": "05:30 PM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    },
    {
      "sno": 2,
      "name": "Jane Smith",
      "actualShift": "Night Shift",
      "entryTime": "09:00 PM",
      "exitTime": "06:00 AM",
      "entryStatus": "Late",
      "exitStatus": "Pending"
    },
    {
      "sno": 3,
      "name": "Michael Brown",
      "actualShift": "Morning Shift",
      "entryTime": "08:45 AM",
      "exitTime": "05:40 PM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    },
    {
      "sno": 4,
      "name": "Emily Davis",
      "actualShift": "Evening Shift",
      "entryTime": "02:00 PM",
      "exitTime": "10:00 PM",
      "entryStatus": "Early",
      "exitStatus": "Completed"
    },
    {
      "sno": 5,
      "name": "David Wilson",
      "actualShift": "Morning Shift",
      "entryTime": "08:15 AM",
      "exitTime": "05:15 PM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    },
    {
      "sno": 6,
      "name": "Olivia Martinez",
      "actualShift": "Night Shift",
      "entryTime": "10:00 PM",
      "exitTime": "07:00 AM",
      "entryStatus": "Late",
      "exitStatus": "Pending"
    },
    {
      "sno": 7,
      "name": "William Anderson",
      "actualShift": "Morning Shift",
      "entryTime": "08:55 AM",
      "exitTime": "05:35 PM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    },
    {
      "sno": 8,
      "name": "Sophia Thomas",
      "actualShift": "Evening Shift",
      "entryTime": "02:30 PM",
      "exitTime": "10:30 PM",
      "entryStatus": "Early",
      "exitStatus": "Completed"
    },
    {
      "sno": 9,
      "name": "James Taylor",
      "actualShift": "Morning Shift",
      "entryTime": "08:40 AM",
      "exitTime": "05:45 PM",
      "entryStatus": "Late",
      "exitStatus": "Pending"
    },
    {
      "sno": 10,
      "name": "Isabella White",
      "actualShift": "Night Shift",
      "entryTime": "09:30 PM",
      "exitTime": "06:30 AM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    },
    {
      "sno": 11,
      "name": "Ethan Harris",
      "actualShift": "Morning Shift",
      "entryTime": "08:20 AM",
      "exitTime": "05:25 PM",
      "entryStatus": "Early",
      "exitStatus": "Completed"
    },
    {
      "sno": 12,
      "name": "Mia Martin",
      "actualShift": "Evening Shift",
      "entryTime": "03:00 PM",
      "exitTime": "11:00 PM",
      "entryStatus": "On Time",
      "exitStatus": "Completed"
    }
  ];  